// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__FW0JA","label":"SetPasswdForm_label__117AB"};